import { set } from 'Global/Helpers/objectHelpers'

import { SIGN_OUT } from 'Global/Stores/auth'

const MESSAGE_ERROR_HIDE = 'GLOBAL/MESSAGE/ERROR/HIDE'
const MESSAGE_ERROR_SHOW = 'GLOBAL/MESSAGE/ERROR/SHOW'
const MESSAGE_SUCCESS_HIDE = 'GLOBAL/MESSAGE/SUCCESS/HIDE'
const MESSAGE_SUCCESS_SHOW = 'GLOBAL/MESSAGE/SUCCESS/SHOW'

export const messageErrorHide = () => ({
  type: MESSAGE_ERROR_HIDE,
})

export const messageErrorShow = message => ({
  payload: message,
  type: MESSAGE_ERROR_SHOW,
})

export const messageSuccessHide = () => ({
  type: MESSAGE_SUCCESS_HIDE,
})

export const messageSuccessShow = message => ({
  payload: message,
  type: MESSAGE_SUCCESS_SHOW,
})

const initialState = {
  error: { message: '', visible: false },
  success: { message: '', visible: false },
}

const reducer = (state = initialState, action) => {
  const { payload, type } = action

  switch (type) {
    case MESSAGE_ERROR_HIDE:
      return set(`error`, { message: '', visible: false }, state)

    case MESSAGE_ERROR_SHOW:
      return set(`error`, { message: payload, visible: true }, state)

    case MESSAGE_SUCCESS_HIDE:
      return set(`success`, { message: '', visible: false }, state)

    case MESSAGE_SUCCESS_SHOW:
      return set(`success`, { message: payload, visible: true }, state)

    case SIGN_OUT:
      return initialState

    default:
      return state
  }
}

export default reducer
